import React from 'react';
import { SRow, SCol } from '@avalara/skylab-sdk/react';
import ResourceTile from '../../shared/resource-tile';
import { content } from './content';
const Resources = () => (React.createElement("div", { className: 'pad-left-sm pad-right-sm' },
    React.createElement(SRow, null,
        React.createElement(SCol, { span: '12', center: '', className: 'pad-top-lg' },
            React.createElement("h1", { "data-ref": 'buy.signup.thankyou.resources.header', className: 'text-center' }, "While you wait"))),
    React.createElement(SRow, null, content.map(({ title, textContent, buttonText = '', link = '' }, i) => (React.createElement(ResourceTile, { title: title, textContent: textContent, buttonText: buttonText, link: link, key: i }))))));
export default Resources;
